module.exports = __webpack_public_path__ + "img/icon_vetor.e4607d5d.28ff090e.svg";